import Vue from 'vue'

export const getCompanyId = () => {
  const user = Vue.prototype.$session.get('cas_user')
  return user.role === 'seller' ? user.shipper.id : user.organization.id
}